import React from 'react'
import TopNav from '../../Layouts/TopNav'
import BottomFooter from '../../Layouts/BottomFooter'
import TeamComp from '../../components/Homepage/TeamComp'

const Team = (props) => {
    return (

        <div className="Homepage">
            <TopNav />
            <TeamComp />
            <BottomFooter />
        </div>

    )
}

export default Team;